
import { Component, Prop } from "vue-property-decorator";
import { DURATION_REGEX, parse } from "@util/dates-and-times/duration";
import Vue from "vue";

@Component({
  name: 'DurationInput'
})
export default class DurationInput extends Vue {
  @Prop({ default: false }) disabled: boolean;

  @Prop() value: string;

  private localValue: string;

  private hasError: boolean = false;

  created() {
    this.localValue = this.value;
  }

  handleInput(val: string) {
    this.localValue = val;

    this.hasError = !this.localValue
        || this.localValue
          && (
              !DURATION_REGEX.test(this.localValue)
            || parse(this.localValue, "d") > 1
            || parse(this.localValue, "m") < 10
          )

    this.$emit('error', this.hasError);
  }

  handleBlur() {
    this.$emit('input', this.localValue);
  }

  get pattern() {
    return DURATION_REGEX;
  }
}
